<main id="house" class="info">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('house_title')}}</h1>
            <span class="icon back" @click="app.setPage('Terminal')">
                chevron_left
            </span>
        </div>
    </header>

    <div v-if="app.house.facade_image" class="image-container">
        <img :src="app.house.facade_image" />
    </div>

    <section class="main">
        <template
            v-if="app.display_house_info && (app.house.name || app.house.address || app.house.phone || app.house_guide_url)"
        >
            <div class="information">
                <span before-icon="domain">{{_('house_title')}}</span>
                <table class="info">
                    <tr v-if="app.house.name">
                        <th>{{_('building')}}</th>
                        <td>{{_(app.house.name)}}</td>
                    </tr>
                    <tr v-if="app.house.address">
                        <th>{{_('addr')}}</th>
                        <td>{{app.house.address}}</td>
                    </tr>
                    <tr v-if="app.house.phone">
                        <th>{{_('phone')}}</th>
                        <td>{{app.house.phone}}</td>
                    </tr>
                    <tr v-if="app.house_guide_url">
                        <th>{{_('facility_introduction')}}</th>
                        <td>
                            <a
                                class="house_guide_url"
                                :href="app.house_guide_url"
                                target="_blank"
                            >
                                {{_('access_site')}}
                                <span class="icon">open_in_new</span>
                            </a>
                        </td>
                    </tr>
                </table>
            </div>
        </template>
        <div class="information" v-if="app.display_reserve_info">
            <span before-icon="local_hotel">{{_('reserve_title')}}</span>
            <table class="info">
                <tr>
                    <th>{{_('number_of_rooms')}}</th>
                    <td>{{app.reserve.room_count}}</td>
                </tr>
                <template v-if="samePeriodAllRoom()">
                    <tr>
                        <th>{{_('arrival')}}</th>
                        <td>{{ formatStayDate(app.reserve.checkin) }}</td>
                    </tr>
                    <tr>
                        <th>{{_('departure')}}</th>
                        <td>{{ formatStayDate(app.reserve.checkout) }}</td>
                    </tr>
                </template>
            </table>
        </div>
        <div class="information">
            <span before-icon="meeting_room">{{_('room_info')}}</span>
            <template v-for="(rr, index) in app.reserves_rooms">
                <table class="info">
                    <tr>
                        <th>{{ _('room_count', index + 1) }}</th>
                        <td v-if="app.checkedin">{{ _(rr.name) }}</td>
                    </tr>
                    <template
                        v-if="!samePeriodAllRoom() && app.display_reserve_info"
                    >
                        <tr>
                            <th>{{_('arrival')}}</th>
                            <td>{{ formatStayDate(rr.start_time) }} ~</td>
                        </tr>
                        <tr>
                            <th>{{_('departure')}}</th>
                            <td>~ {{ formatStayDate(rr.end_time) }}</td>
                        </tr>
                    </template>
                    <template v-if="rr.ssid">
                        <tr>
                            <th>{{_('wifi_name')}}</th>
                            <td>{{ rr.ssid }}</td>
                        </tr>
                        <tr>
                            <th>{{_('password')}}</th>
                            <td>{{ rr.wifi_password }}</td>
                        </tr>
                    </template>
                </table>
            </template>
        </div>
    </section>

    <section v-if="app.house.map_point">
        <span class="map-title" before-icon="place">{{ _('access') }}</span>
        <iframe
            :src="'https://www.google.com/maps/embed/v1/place?key='+ app.mapApiKey +'&q='+ app.house.map_point"
        ></iframe>
    </section>

    <tab-bar :page="app.query.page"></tab-bar>
</main>
